import { useState } from 'react'
import PropTypes from 'prop-types'
import { useForm, Controller } from 'react-hook-form'

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Button,
  MenuItem,
  Select,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core'

import { Label } from 'components'

import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import helpers from 'helpers'

const FormDecreaseQuestionnaireLevelDialog = ({
  open,
  setOpen,
  refresh,
  companyId,
}) => {
  const snackbar = useSnackbar()
  const [loading, setLoading] = useState(false)

  const { control, handleSubmit, errors } = useForm({
    defaultValues: {
      level: '',
      shouldResetQuestionsAnswers: false,
    },
  })

  const onSubmit = async (data) => {
    setLoading(true)
    let { level, shouldResetQuestionsAnswers } = data
    try {
      await service.dponet.companies.decreaseQuestionnaireLevel({
        companyId,
        level,
        shouldResetQuestionsAnswers,
      })

      snackbar.open({
        message: 'Nível dos questionários alterado com sucesso!',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        variant: 'error',
        message: helpers.formatters.errorMessage(error?.response?.data?.error),
      })
    }
    setLoading(false)
    setOpen(false)
    refresh()
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle disableTypography>
          <Box>
            <Typography variant="h5">
              Diminuir nível dos Questionários
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Box>
            <Typography variant="h4" align="center">
              Tem certeza que deseja diminuir o nível dos questionários desta
              empresa? Não será possível reverter esta ação!
            </Typography>
          </Box>
          <Box pt={2}>
            <Label
              title="Novo nível dos questionários"
              description="Selecione o nível desejado (1 ou 2)"
              item
              xs={12}
              padBuTitle={0}
            >
              <Controller
                as={
                  <Select
                    color="primary"
                    variant="outlined"
                    error={!!errors.level}
                    onKeyDown={(e) => {
                      e.stopPropagation()
                    }}
                    fullWidth
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Selecione o nível
                    </MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                  </Select>
                }
                control={control}
                name="level"
                mode="onBlur"
                rules={{ required: 'Selecione o nível' }}
              />
              {errors?.level && (
                <Typography color="error" variant="body2">
                  {errors.level.message}
                </Typography>
              )}
            </Label>
          </Box>
          <Box pt={2}>
            <Label
              title="Resetar respostas"
              description="Deseja resetar todas as respostas dos questionários?"
              item
              xs={12}
              padBuTitle={0}
            >
              <Controller
                as={
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        onKeyDown={(e) => {
                          e.stopPropagation()
                        }}
                      />
                    }
                    label="Sim, resetar todas as respostas"
                  />
                }
                control={control}
                name="shouldResetQuestionsAnswers"
                mode="onBlur"
              />
            </Label>
          </Box>
        </DialogContent>
        <DialogActions p={2}>
          <Box pl={2} pr={1}>
            <Button
              type="button"
              variant="outlined"
              onClick={() => setOpen(false)}
            >
              Cancelar
            </Button>
          </Box>
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disabled={loading}
          >
            {loading ? 'Aguarde...' : 'Diminuir nível'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

FormDecreaseQuestionnaireLevelDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
  companyId: PropTypes.number,
}

FormDecreaseQuestionnaireLevelDialog.defaultProps = {
  refresh: () => {},
  setOpen: () => {},
}

export default FormDecreaseQuestionnaireLevelDialog
